import { connect } from 'react-redux';
import { editPosPayment } from '../../actions/pos_actions';
import EditPosPaymentModal from '../../components/Sales/EditPosPaymentModal';

const mapStateToProps = (state) => {
  return {
    editingPosPayment: state.pos.editingPosPayment,
    editedPosPayment: state.pos.editedPosPayment,
    editPosPaymentError: state.pos.editPosPaymentError,
  };
};

const EditPosPaymentModalContainer = connect(mapStateToProps, { editPosPayment })(EditPosPaymentModal);

export default EditPosPaymentModalContainer;



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/EditPosPaymentModal.jsx